// extracted by mini-css-extract-plugin
export default {"share":"share-article-buttons_share__IKu+S","icons":"share-article-buttons_icons__3ErQF"};